import styled from 'styled-components';

import { dimension } from '@creditornot/cb-ingredients/design-tokens';
import { Stack } from 'common/components/cookbook/Stack';
import { TextLink } from 'common/components/cookbook/TextLink';
import { Heading } from 'common/components/cookbook/Typography/Heading';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Root = styled(Stack)`
  height: 100%;
  padding: ${dimension.spaceBroadXxxlarge};
  text-align: center;
`;

function NotFoundView() {
  const f = useFormatMessage();

  return (
    <Root gap="regularXlarge" justifyContent="center">
      <Heading level={1} variant="headline">
        {f('not_found.page_not_found')}
      </Heading>
      {f('not_found.nothing_here')}
      <TextLink to="/">{f('common.go_to_main_page')}</TextLink>
    </Root>
  );
}

export default NotFoundView;
